import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { SettingsPageView } from '@/components/settings/settings-page-view';
import { ALL_SETTINGS_SECTIONS, type SettingsSection } from '@/components/settings/settings-nav';

export const Route = createFileRoute('/settings')({
    validateSearch: (search: Record<string, unknown>): { section: SettingsSection } => {
        const raw = search.section;
        const section = ALL_SETTINGS_SECTIONS.includes(raw as SettingsSection)
            ? (raw as SettingsSection)
            : 'appearance';
        return { section };
    },
    component: SettingsRoute,
});

function SettingsRoute() {
    const { section } = Route.useSearch();
    const navigate = useNavigate();

    return (
        <SettingsPageView
            section={section}
            onSectionChange={(next) =>
                void navigate({ to: '/settings', search: { section: next } })
            }
        />
    );
}
